export default __webpack_public_path__ + "static/screenshot_purple-d46384c597f56f44e4c1e3c7a4bb237e.png";